import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPhotosLibrary from "@/pages/admin/AdminPhotosLibrary";

export const Route = createFileRoute("/admin/photos/library")({
  head: () => pageHead("Admin \u2014 Photos \u2014 Library \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPhotosLibrary,
});
